module.exports = __webpack_public_path__ + "Flama-BoldItalic.woff?d8af9e360a5b01bc6ba76ea462be0ecd";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BoldItalic.woff
// module id = 912
// module chunks = 0